import axios from "../../utils/axios";

async function addAddOn(productId, data) {
  return await axios.post(`/single/products/${productId}/addons`, data);
}
async function updateAddOn(productId, addonId, data) {
  return await axios.patch(
    `/single/products/${productId}/addons/${addonId}`,
    data
  );
}
async function deleteAddOn(productId, addonId) {
  return await axios.delete(`/single/products/${productId}/addons/${addonId}`);
}
async function getAddOns(productId, params) {
  return await axios.get(`/single/products/${productId}/addons`, { params });
}
async function getAddOnById(productId, addonId) {
  return await axios.get(`/single/products/${productId}/addons/${addonId}`);
}
async function updateManyAddOns(productId, data) {
  return await axios.patch(
    `/single/products/${productId}/addons/update-many`,
    data
  );
}

async function createManyAddOns(productId, data) {
  return await axios.post(`/single/products/${productId}/addons`, data);
}
async function deleteManyAddOns(productId, data) {
  return await axios.delete(
    `/single/products/${productId}/addons/delete-many`,
    { data }
  );
}

export const addOnsService = {
  addAddOn,
  updateAddOn,
  deleteAddOn,
  getAddOns,
  getAddOnById,
  updateManyAddOns,
  deleteManyAddOns,
  createManyAddOns,
};
